<template>
    <div>
        <label class="label" :class="{ white: white }" @click="toggle">
            <input v-model="checked" type="checkbox" :disabled="disabled">
            <span class="text">
                <slot />
            </span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        white: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        checked: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            }
        }
    },
    methods: {
        toggle(e) {
            // if clicking a link inside the label, we will not toggle the checkbox
            // allows for having links to eg. terms inside the label
            if (e.target.tagName.toLowerCase() === "a") {
                e.stopPropagation();
                e.preventDefault();
                const href = e.target.getAttribute("href");
                const target = e.target.getAttribute("target");
                if (href) window.open(href, target);
            }
        }
    }
};
</script>

<style scoped lang="scss">
$element-InputCheckbox-border-radius: 1em !default;
$element-InputCheckbox-width: 1em !default;
$element-InputCheckbox-color: $color-primary !default;
$element-InputCheckbox-label-color: $body-color !default;
$element-InputCheckbox-border-width: 2px !default;

.label {
    position: relative;
    user-select: none;
    display: flex;
}

.label input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

.label .text {
    padding-left: 2em;
    color: $element-InputCheckbox-label-color;
}

.label .text::before {
    display: block;
    width: $element-InputCheckbox-width;
    height: 1em;
    border: 2px solid $element-InputCheckbox-color;
    border-radius: $element-InputCheckbox-border-radius;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
}

.label.white .text::before {
    border-color: white;
}

.label.white,
.label.white .text {
    color: white;
}

.label input:focus + .text::before {
    outline: $element-InputCheckbox-color auto 3px;
}

.label input:checked + .text::before {
    background: $element-InputCheckbox-color;
    box-shadow: inset 0px 0px 1px 2px white;
}

.label.white input:focus + .text::before {
    outline: white auto 3px;
}

.label.white input:checked + .text::before {
    background: white;
    box-shadow: inset 0px 0px 1px 2px $element-InputCheckbox-color;
}

label input:disabled + .text {
    &::before {
        border-color: rgba($element-InputCheckbox-color, 40%) !important;
    }
    cursor: not-allowed;
    color: rgba($element-InputCheckbox-label-color, 40%) !important;
}
</style>
